// extracted by mini-css-extract-plugin
export default {"rank":"Rank_rank__z4bpK","diamond":"Rank_diamond__ZVADu","golden":"Rank_golden__I4PrE","silver":"Rank_silver__qjx7c","bronze":"Rank_bronze__x4syc"};